import { getUserData } from "../store/persistStore";
import _ from "lodash";
import i18n from "../i18n";
import makeRequest from "./makeRequest";

export const logEvent = (data) => {
  const userData = getUserData();

  const result = {
    ...data,
    properties: {
      ...(data.properties || {}),
      userId: userData ? getUserData().id : null,
      lang: i18n.language,
    },
  };
  //console.log(`Logged event: ${result.name}`);
  //console.log(`Logged data: `, result);
  window.insight.trackEvent(result);
};

export const logPageView = (name) => {
  const userData = getUserData();
  window.insight.trackPageView({
    name,
    properties: {
      userId: userData ? getUserData().id : null,
      lang: i18n.language,
    },
  });
};

const formatAssessmentAnswers = (answers) => {
  let result = [];
  _.forEach(answers, (item) => {
    result = [...result, `${item.questionTitle}: ${item.answer.title}`];
  });
  return result.join("; ");
};

export const logInteractionEvent = (event, data) => {
  const userData = getUserData();
  const postData = {
    ...data,
    userId: userData ? userData.id : null,
    lang: i18n.language,
    email: userData ? userData.email : null,
  };

  switch (event) {
    case "TermsAccepted":
      makeRequest("post", "/api/events/terms-accepted", postData);
      break;
    case "TopicOpened":
      makeRequest("post", "/api/events/topic-opened", postData);
      break;
    case "TopicCompleted":
      makeRequest("post", "/api/events/topic-completed", postData);
      break;
    case "ActivityStarted":
      makeRequest("post", "/api/events/activity-started", postData);
      break;
    case "ActivityCompleted":
      makeRequest("post", "/api/events/activity-completed", postData);
      break;
    case "LessonCompleted":
      makeRequest("post", "/api/events/lesson-completed", postData);
      break;
    case "ModuleCompleted":
      makeRequest("post", "/api/events/module-completed", postData);
      break;
    case "SectionCompleted":
      makeRequest("post", "/api/events/section-completed", postData);
      break;
    case "UserLoggedIn":
      makeRequest("post", "/api/events/user-logged-in", postData);
      break;
    case "Shared":
      makeRequest("post", "/api/events/shared", postData);
      break;
    case "BadgeShared":
      makeRequest("post", "/api/events/badge-shared", postData);
      break;
    case "OrientationCompleted":
      makeRequest("post", "/api/events/orientation-completed", postData);
      break;
    case "LinkFollowed":
      makeRequest("post", "/api/events/link-followed", postData);
      break;
    case "TemplateDownloaded":
      makeRequest("post", "/api/events/template-downloaded", postData);
      break;
    case "Affiliate":
      makeRequest("post", "/api/events/affiliate", postData);
      break;
    case "AssessmentCompleted":
      makeRequest("post", "/api/events/assessment-completed", {
        ...postData,
        answers: formatAssessmentAnswers(postData.answers),
      });
      break;
    default:
      return null;
  }
};
